import { styled } from '@mui/material/styles';
import { getIdvThemeTokens } from './themeTokens';

export const TabBody = styled('div')(({ theme }) => {
  const t = getIdvThemeTokens(theme);
  return {
    padding: '22px 26px 26px',
    color: t.text,
    colorScheme: t.colorScheme,
  };
});
